import { ModalActionButton } from '@topconagriculture/modal';
import React from 'react';
import { useTranslation } from 'react-i18next';
export const ViewMore = (props) => {
    const { disabled, viewMore } = props;
    const { t } = useTranslation();
    return React.createElement(ModalActionButton, { disabled: disabled, action: viewMore, btnLabel: t('widget:generic:footer_text') });
};
//# sourceMappingURL=ViewMore.js.map